var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNdxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0091BA",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.062 36h3.293V20H13.05L9 23.044v2.872l3.997-2.68h.065V36ZM26.018 36c3.975 0 6.386-3.076 6.386-7.995v-.021c0-4.919-2.411-7.984-6.386-7.984s-6.386 3.065-6.386 7.984v.021c0 4.92 2.411 7.995 6.386 7.995Zm0-2.593c-1.955 0-3.073-2.004-3.073-5.402v-.021c0-3.397 1.118-5.39 3.073-5.39 1.955 0 3.073 1.993 3.073 5.39v.021c0 3.398-1.118 5.402-3.073 5.402ZM40.614 36C44.59 36 47 32.924 47 28.005v-.021C47 23.065 44.589 20 40.614 20s-6.386 3.065-6.386 7.984v.021c0 4.92 2.411 7.995 6.386 7.995Zm0-2.593c-1.955 0-3.073-2.004-3.073-5.402v-.021c0-3.397 1.118-5.39 3.073-5.39 1.955 0 3.074 1.993 3.074 5.39v.021c0 3.398-1.119 5.402-3.074 5.402Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdxLogo);
export default __webpack_public_path__ + "static/media/ndx-logo.26b959af6e2bc88bf4ae226490937d2f.svg";
export { ForwardRef as ReactComponent };